//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import CustomMultiselect from "~/components/common/CustomMultiselect.vue";

export default BaseCmsBlock.extend({
  name: "PartnerCalculatorBlock",

  data: function () {
    const currencyMask = function (rawValue) {
      const numberMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: '.',
        thousandsSeparatorSymbol: ' ',
        decimalLimit: 0,
      });
      rawValue = rawValue.replace(',', '.');
      const mask = numberMask(rawValue);
      return mask;
    };
    const currencyMaskDecimal = function (rawValue) {
      const numberMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        decimalSymbol: '.',
        thousandsSeparatorSymbol: ' ',
        decimalLimit: 2,
      });
      rawValue = rawValue.replace(',', '.');
      const mask = numberMask(rawValue);
      return mask;
    };

    return {
      form: {
        profits: null,
        price: "0",
        ports: "0",
      },

      search: "",

      currencyMask,
      currencyMaskDecimal
    }
  },

  mounted: function () {
    this.form.profits = this.countries?.[0];
  },

  computed: {
    getCurrency: function () {
      return this.$store.getters["currency/currentCurrency"];
    },
    getCurrencySumbol: function () {
      return Boolean(this.getCurrency === 'rub') ? '₽' : '$'
    },
    currentLanguage: function () {
      return this.$i18n?.locale || this.$i18n?.defaultLocale
    },
    countries: function () {
      const newCountry = [];
      (this.cfgs?.profits || []).forEach((t) => {
        if (!t.country) {
          return;
        }

        const country = JSON.parse((t?.country || {}))?.[this.currentLanguage];
        newCountry.push({
          ...t,
          country
        })
      });
      if (this.search <= 2) {
        return newCountry
      }

      const search = String(this.search || '').toLowerCase();
      return [...newCountry]
        .filter((t) => {
          return Boolean(String(t.country || '').toLowerCase().includes(search))
        })
    },

    percentProfit: function () {
      const formPorts = Number.parseFloat(String(this.form.ports || 0).replace(/ /g,''));
      const formProfit = Number.parseFloat(String(this.$convertCurrency((this.form.profits?.profit || 0))).replace(/ /g,''));
      const formPrice = Number.parseFloat(String(this.form.price || 0).replace(/ /g,''));

      const profit = formPorts * formProfit;
      const consumption = formPorts * formPrice;
      const totalProfit = (profit - consumption) * 92;
      if (totalProfit <= 0) {
        return 0
      }
      if (consumption <= 0) {
        return 0
      }

      const spentMoney = (formPorts * formPrice);
      const earnedMoney = (formPorts * formProfit);
      const differenceMoney = earnedMoney - spentMoney;
      const differencePercent = Math.floor((differenceMoney / spentMoney) * 100);
      if (differencePercent > 0) {
        return `+${differencePercent}`
      }

      return differencePercent
    },
  },

  components: {
    CustomMultiselect
  },

  methods: {
    _calcMathProfit: function (countMount) {
      const currency = this.$store?.state?.currency?.currentCurrency;
      const _currencyConverRub = Boolean(currency === 'usd') ? 'usd' : 'rub';

      const formPorts = Number.parseFloat(String(this.form.ports || 0).replace(/ /g,''));

      let formPrice = Number.parseFloat(String(this.$convertCurrency((this.form.price || 0), _currencyConverRub)).replace(/ /g,''));
      if (currency === 'rub') {
        formPrice = Number.parseFloat(String((this.form.price || 0)).replace(/ /g,''))
      }

      const formProfit = Number.parseFloat(String(this.form.profits?.profit).replace(/ /g,''));

      const spentMoney = (formPorts * formPrice);
      const earnedMoney = (formPorts * formProfit);
      const differenceMoney = earnedMoney - spentMoney;
      const value = Math.floor(differenceMoney * countMount);
      const valueCurency = this.$convertCurrency(value);
      const valueFormater = this.$numberFormat(valueCurency);

      return valueFormater
    },
    _calcMathProfit_: function (countMount) {
      const formPorts = Number.parseFloat(String(this.form.ports || 0).replace(/ /g,''));
      const formPrice = Number.parseFloat(String(this.form.price || 0).replace(/ /g,''));
      const formProfit = Number.parseFloat(String(this.form.profits?.profit || 0).replace(/ /g,''));

      const profit = formPorts * formProfit;
      const consumption = formPorts * formPrice;

      const spentMoney = (formPorts * formPrice);
      const earnedMoney = (formPorts * formProfit);
      const differenceMoney = earnedMoney - spentMoney;

      let values = (differenceMoney) * countMount;
      values = this.$convertCurrency(values);

      return this.$numberFormat(values)
    },

    changeSearch: function (val) {
      this.search = val;
    },
  }
})
